import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { concat, tap, Subscription, Subject } from 'rxjs';
import { map, switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { Person } from 'src/app/shared/person';
import { Client } from 'src/app/shared/client';
import { Document } from 'src/app/shared/document';

import { ClientApiService } from 'src/app/services/client-api.service';

@Component({
  selector: 'app-new-document-dlg-companies',
  templateUrl: './new-document-dlg-companies.component.html',
  styleUrls: ['./new-document-dlg-companies.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgCompaniesComponent implements OnInit, OnChanges, OnDestroy {

  @Input() parentDocument: Document;
  @Input() newDocument: Document;

  @Input() cliComLabel: string = 'Покупатель';
  @Input() cliPerLabel: string = 'Ответственный';
  @Input() pcoComLabel: string = 'Юридическое лицо покупателя';
  @Input() pcoPerLabel: string = 'Ответственный';

  private _cliCompanyQuery: Subscription;

  cliCompany: Client;
  pcoCompany: Client;
  cliPerson: Person;
  pcoPerson: Person;

  private cliCompanySubs$ = new Subject<number>();

  parentDocumentId: number;

  private _newDocumentUpdateQuery: Subscription = null;

  private newDocumentUpdateSubs$ = new Subject<Document>();
  @Output() newDocumentUpdate: EventEmitter<Document> = new EventEmitter();

  constructor(
    private cliApi: ClientApiService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** NewDocumentDlgCompaniesComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgCompaniesComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** NewDocumentDlgCompaniesComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

    //  switch (propName) {

    //    case 'parentDocument':
    //      break;
    //  }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgCompaniesComponent in ngOnDestroy')

    if (this._cliCompanyQuery) { this._cliCompanyQuery.unsubscribe(); }
    if (this._newDocumentUpdateQuery) { this._newDocumentUpdateQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgCompaniesComponent in ngOnInit');

    this._newDocumentUpdateQuery =
      this.newDocumentUpdateSubs$.pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(document => environment.production || console.log('*** NewDocumentDlgCompaniesComponent newDocumentUpdateSubs$: ' + JSON.stringify(document))),
        map(document => this.newDocumentUpdate.emit(document)),
      )
        .subscribe();

    this._cliCompanyQuery =
      this.cliCompanySubs$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((cli: number) => this.cliApi.getClientById(cli))
      )
        .subscribe((data) => {
          console.log('*** NewDocumentDlgCompaniesComponent cliCompanySubs$: ' + JSON.stringify(data));

          this.cliCompany = data[0];

          if (this.newDocument && this.cliCompany && this.cliCompany.CURID) {
            this.newDocument.DOCCURRID = this.cliCompany.CURID;
            this.newDocumentUpdateSubs$.next(this.newDocument);
          }
        });
  }

  cliCompanySelected(event) {
    console.log('*** NewDocumentDlgCompaniesComponent cliCompanySelected  ' + JSON.stringify(event));
    this.newDocument.DOCCLIENTSID = event;
    this.newDocument.DOCPCOCLIID = event;

    this.cliCompanySubs$.next(this.newDocument.DOCCLIENTSID);
  }

  cliPersonSelected(event) {
    console.log('*** NewDocumentDlgCompaniesComponent cliPersonSelected  ' + JSON.stringify(event));
    this.newDocument.DOCPERSONID = event;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  pcoCompanySelected(event) {
    console.log('*** NewDocumentDlgCompaniesComponent pcoCompanySelected  ' + JSON.stringify(event));
    this.newDocument.DOCPCOCLIID = event;

    /*
     * TODO: Check whether we can use Customer's Currency settings
     */
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  pcoPersonSelected(event) {
    console.log('*** NewDocumentDlgCompaniesComponent pcoPersonSelected  ' + JSON.stringify(event));
    this.newDocument.DOCPCOPERID = event;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }
}
